module.exports = __webpack_public_path__ + "img/banner04_info_pic2.edd655f0.jpg";